import React, { Component } from "react";
import ReactModal from "react-modal";
import { apiUrl, apiUrl4 } from "../../config/config";
import axios from "axios";
import Dropdown from "react-dropdown";
import "react-dropdown/style.css";
import Loader from "react-loader-spinner";
import AnalyzingSpinner from "./AnalyzingSpinner";
import { enqueue as enqueueAnalysis } from "./analysisQueue";
import { start } from "@popperjs/core";

class AddModal extends Component {
  constructor() {
    super();
    this.state = {
      showModal: false,
      showModalNew: false,
      showModalSpinner: false,
      clickdata: "",
      startProp: "",
      userid: "",
      showInputPopup: false,
      showInvertorpopup: false,
      showAnlayseone: false,
      showAnalysetwo: false,
      showAnalysethree: false,
      showAnalyzefour: false,
      inputValue: "",
      treemenu: [],
      treemenurev: [],
      starttime: "",
      endtime: "",
      lastindex: "",
      analyzeModal: "",
      showDeletePopup: false,
      showdatacopypopup: false,
      correctTime: "",
      showLoading: false,
      showSuccessModal: false,
      successMessage: "",
      showProgressModal: false,
      currentProgress: 0,
      progressInterval: null,
      progressComplete: false,
      showProgressPercent: false,
      analyzeServer: "Server 1",
      singleDataset: true,
      // Phase tracking — matches backend `analysis_phase` enum:
      //   queued → ssh_connecting → ssh_connected → running → complete
      //   any → failed (terminal)  |  running → stuck (auto-flagged by watcher)
      analysisPhase: null,           // string from backend
      analysisPhaseDetail: null,     // human-readable detail
      analysisNodeHost: null,        // e.g. "vm-a1" — server actually running the job
    };
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handleCloseModalNew = this.handleCloseModalNew.bind(this);
    this.handleCloseModalSpinnerNew =
      this.handleCloseModalSpinnerNew.bind(this);
    this.handleDeletePopupClose = this.handleDeletePopupClose.bind(this);
    this.handleDeletePopupOk = this.handleDeletePopupOk.bind(this);
  }
  componentDidMount() {
    ReactModal.setAppElement("body");
    window.analyzeLink = "";
  }

  // Click handler for Analytics 2 image (no selection required)
  async handleAnalytics2Click() {
    const userId = this.state.userid;
    try {
      console.log("Preparing Analytics 2...");
      await this.resetProgress(userId);

      // Trigger server analysis first, then start polling for progress
      const fallback = this.state.clickdata ? this.state.clickdata.replace(/%20/g, " ") : "";
      const startdate = this.state.starttime && this.state.starttime.trim() !== "" ? this.state.starttime.replace(/%20/g, " ") : fallback;
      const enddate = this.state.endtime && this.state.endtime.trim() !== "" ? this.state.endtime.replace(/%20/g, " ") : fallback;

      const response = await axios.post(
        `${apiUrl4}api/common/Analyse_New_Modal1`,
        {
          userid: userId,
          databaseid: this.state.clickdata,
          startdate,
          enddate,
        },
        { timeout: 5 * 60 * 1000 }
      );
      console.log("Analyse_New_Modal1 response:", response.data);

      // start progress after successfully triggering the analysis
      this.startProgressPolling(userId, "analytics2", 2000);
    } catch (err) {
      console.error("Error calling Analyse_New_Modal:", err);
      this.stopProgressPolling();
      this.setState({ showModalSpinner: false });
    }
  }

  componentWillReceiveProps(nextProps) {
    // Right-click on a database id in the sidebar opens the algorithm picker
    // directly. The old Analyze/Delete intermediate popup is no longer used —
    // Delete is now a card inside the picker's Data Conditioning section.
    const opening = !this.props.isOpen && nextProps.isOpen;
    this.state.clickdata = nextProps.clickdb;
    this.state.showModalNew = nextProps.isOpen;
    this.state.userid = nextProps.userid;
    this.state.startProp = nextProps.start;
    // Pre-load treemenu and default start/end times to the right-clicked dataset
    if (opening && nextProps.userid && nextProps.clickdb) {
      this.openAnalyzemodal();
    }
  }

  maybeReload(code) {
    const progressCodes = ["first-code", "second-code", "third-code", "fourth-code", "analytics2"];
    if (!progressCodes.includes(code)) {
      window.location.reload();
    }
  }
  handleCloseModal() {
    this.setState({ showModal: false });
    this.props.onResetModal();
  }

  handleCloseModalNew() {
    this.setState({ showModalNew: false });
    this.props.onResetModal();
  }
  handleCloseModalSpinnerNew() {
    this.setState({ showModalSpinner: false });
  }
  handleOpenModalSpinnerNew() {
    // Only open the lightweight spinner when the full progress modal is not shown
    if (!this.state.showProgressModal) {
      this.setState({ showModalSpinner: true });
    }
  }

  // Reset progress to 0 on server before starting an analysis
  async resetProgress(userId) {
    try {
      await axios.post(`${apiUrl}api/common/UpdateProgressStatus/${userId}`);
    } catch (err) {
      console.error('Failed to reset progress:', err);
    }
  }
  async openAnalyzemodal() {
    const response = await axios.get(
      `${apiUrl}api/common/patinentmenutreeNew?userid=${this.state.userid}`
    );
    // console.log('treemenu:!!!!!!!!!!',response.data)
    const treemenu = response.data;
    let optionnewon = []; // For ascending order
    let optionnewendon = []; // For descending order

    // Iterate over each date group in treemenu
    Object.keys(treemenu).forEach((dateKey) => {
      treemenu[dateKey].forEach((entry) => {
        const MainTimeon = entry.date.split("T");
        const timeon = MainTimeon[1].split("+")[0]; // Extract time portion, ignoring timezone

        // Create the formatted time string: "date time"
        const timeStr = `${dateKey} ${timeon}`;

        // Push to both arrays
        optionnewon.push(timeStr);
        optionnewendon.push(timeStr);
      });
    });

    // Sort optionnewon (ascending order) by full date-time
    optionnewon.sort((a, b) => {
      const fullDateA = new Date(a); // Convert full date-time string to Date object
      const fullDateB = new Date(b); // Convert full date-time string to Date object
      return fullDateA - fullDateB; // Ascending order: compare full date-time
    });

    // Sort optionnewendon (descending order) by full date-time
    optionnewendon.sort((a, b) => {
      const fullDateA = new Date(a); // Convert full date-time string to Date object
      const fullDateB = new Date(b); // Convert full date-time string to Date object
      return fullDateB - fullDateA; // Descending order: compare full date-time
    });

    // Output the results
    // console.log('Sorted Ascending:', optionnewon);
    const formattedOptionNewEndon = optionnewendon.map((value, index) => ({
      index,
      value,
    }));
    const formattedOptionNewStarton = optionnewon.map((value, index) => ({
      index,
      value,
    }));

    this.setState({ treemenu: formattedOptionNewEndon });
    this.setState({ treemenurev: formattedOptionNewStarton });
    const lenght = this.state.treemenu.length;
    // console.log("treemenu", lenght);
    this.setState({ lastindex: lenght });
    this.setState({ showModal: false });
    this.setState({ showModalNew: true });
    this.setState({ starttime: this.state.clickdata.replace("%20", " ") });
    this.setState({ endtime: this.state.clickdata.replace("%20", " ") });
    this.setState({ inputValue: "1.5" });
    // console.log("st time", this.state.clickdata.replace("%20",' '));
    // console.log("ed time", this.state.clickdata);
  }
  handleInputChange(e) {
    this.setState({ inputValue: e.target.value });
  }
  handleInputPopupClose() {
    this.setState({ showInputPopup: false });
    this.setState({ showInvertorpopup: false });
    this.setState({ showAnlayseone: false });
    this.setState({ showAnalysetwo: false });
    this.setState({ showdatacopypopup: false });
    this.setState({ showAnalysethree: false });
    this.setState({ showAnalyzefour: false });
  }
  handleInputPopupOk() {
    if (!this.state.inputValue) return;

    const userId = this.state.userid;
    const startTime = this.state.starttime.replace(/ /g, "%20");
    const endTime = this.state.endtime.replace(/ /g, "%20");

    // Close the input modal and show the progress spinner while the API runs
    this.setState({
      showInputPopup: false,
      showInvertorpopup: false,
      showAnlayseone: false,
      showAnalysetwo: false,
      showAnalysethree: false,
      showAnalyzefour: false,
      showModalNew: false,
      showModalSpinner: true,
    });

    axios
      .post(`${apiUrl}api/common/amplitude_increase`, {
        userid: userId,
        startdate: startTime.replace(/%20/g, " "),
        enddate: endTime.replace(/%20/g, " "),
        val: parseFloat(this.state.inputValue),
      })
      .catch((err) => {
        console.error("Amplitude increase API error:", err);
      })
      .finally(() => {
        this.setState({ showModalSpinner: false });
        this.handleCloseModal();
        window.location.reload();
      });
  }

  // Queue this analysis instead of running it now. Uses the same
  // code/server/time-range selection the OK button would; the queue
  // runner executes entries strictly one at a time and the list shows
  // on the Analysis Dashboard (see analysisQueue.js).
  handleAddToQueue = async () => {
    const codeType = this.state.analyzeModal;
    const queueable = ["first-code", "second-code", "third-code", "fourth-code"];
    if (!queueable.includes(codeType)) return;

    let startdate = this.state.starttime || "";
    let enddate = this.state.endtime || "";
    if (!startdate || !enddate) {
      const fallback = this.state.clickdata ? this.state.clickdata.replace(/%20/g, " ") : "";
      if (!startdate) startdate = fallback;
      if (!enddate) enddate = fallback;
    }

    this.handleInputPopupClose();
    this.setState({ showModalNew: false });

    let message;
    try {
      const added = await enqueueAnalysis({
        userid: this.state.userid,
        name: this.props.patientName || this.state.userid,
        codeType,
        server: this.state.analyzeServer,
        startdate: startdate.replace(/%20/g, " "),
        enddate: enddate.replace(/%20/g, " "),
      });
      message = added
        ? "Added to analysis queue — the backend runs items one at a time. Track progress on the Analysis Dashboard."
        : "This patient is already in the analysis queue.";
    } catch (err) {
      // Backend queue routes missing/unreachable — say so, don't pretend.
      message =
        "Could not queue: " +
        ((err && err.message) || "backend unreachable") +
        ". Check the analysisQueue routes + worker on this web server.";
    }
    this.setState({ showSuccessModal: true, successMessage: message });
  };

  async handleSelectorOk() {
    const userId = this.state.userid;
    const startTime = this.state.starttime.replace(/ /g, "%20");
    const endTime = this.state.endtime.replace(/ /g, "%20");

    const selectedcode = this.state.analyzeModal;
    const progressCodes = ["first-code", "second-code", "third-code", "fourth-code", "analytics2"];
    this.setState({ showInputPopup: false });
    this.setState({ showInvertorpopup: false });
    this.setState({ showAnlayseone: false });
    this.setState({ showAnalysetwo: false });

    this.setState({ showAnalysethree: false });
    this.setState({ showAnalyzefour: false });
    this.setState({ showModalSpinner: true });
    this.setState({ showModalNew: false });

    // console.log(selectedcode)
    if (selectedcode == "inversion") {
      // showModalSpinner is already true (set above) so progress is visible
      axios
        .post(`${apiUrl}api/common/explicitinvert`, {
          userid: userId,
          startdate: startTime.replace(/%20/g, " "),
          enddate: endTime.replace(/%20/g, " "),
        })
        .catch((error) => {
          console.error("Inversion API error:", error);
        })
        .finally(() => {
          this.setState({ showModalSpinner: false });
          this.handleCloseModal();
          window.location.reload();
        });
    } else if (
      selectedcode === "first-code" &&
      this.state.starttime === this.state.endtime
    ) {
      console.log("start time", startTime, "endtime:", endTime);
      this.setState({ showModalSpinner: true });
      this.startProgressPolling(userId, "first-code");

      try {
        // reset server progress to 0 before starting
        await this.resetProgress(userId);
        let firstEndpoint;
        if (this.state.analyzeServer === "Server 2") {
          firstEndpoint = `${apiUrl4}api/common/Analyse_First_Modal2`;
        } else if (this.state.analyzeServer === "Server 1") {
          firstEndpoint = `${apiUrl4}api/common/First_code_Analyse`;
        } else if (this.state.analyzeServer === "Server 3") {
          firstEndpoint = `${apiUrl4}api/common/Analyse_First_Modal3`;
        } else if (this.state.analyzeServer === "Main Server") {
          firstEndpoint = `${apiUrl4}api/common/Analyse_First_Modal_Main_Server`;
        }
        const response = await axios.post(firstEndpoint, {
          userid: userId,
          startdate: startTime.replace(/%20/g, " "),
          enddate: endTime.replace(/%20/g, " "),
          analyzeServer: this.state.analyzeServer,
        });
        console.log(response);
        this.setState({ showModalSpinner: false });
        this.handleCloseModal();
        if (!progressCodes.includes(selectedcode)) {
          window.location.reload();
        }
      } catch (error) {
        console.error("First Code Analysis API Error (Progress polling continues):", error);
        this.setState({ showModalSpinner: false, showModalNew: true });
      }

      console.log("FULL AI");
    } else if (
      selectedcode === "first-code" &&
      this.state.starttime !== this.state.endtime
    ) {
      this.setState({ showModalSpinner: false });
      this.startProgressPolling(userId, "first-code");
      
      await this.resetProgress(userId);
      let firstEndpointFull;
      if (this.state.analyzeServer === "Server 2") {
        firstEndpointFull = `${apiUrl4}api/common/Analyse_First_Modal2`;
      } else if (this.state.analyzeServer === "Server 1") {
        firstEndpointFull = `${apiUrl4}api/common/First_code_Analyse`;
      } else if (this.state.analyzeServer === "Server 3") {
        firstEndpointFull = `${apiUrl4}api/common/Analyse_First_Modal3`;
      } else if (this.state.analyzeServer === "Main Server") {
        firstEndpointFull = `${apiUrl4}api/common/Analyse_First_Modal_Main_Server`;
      }
      axios.post(firstEndpointFull, {
          userid: userId,
          startdate: startTime.replace(/%20/g, " "),
          enddate: endTime.replace(/%20/g, " "),
          analyzeServer: this.state.analyzeServer,
        })
        .then((response) => {
          console.log(response);
        })
        .catch((error) => {
          console.error("First Code Full Analysis API Error (Progress polling continues):", error);
          try {
            this.startProgressPolling(userId, selectedcode, 2000);
          } catch (e) {
            console.error('Fallback polling start failed:', e);
          }
        })
        .finally(() => {
          this.setState({ showModalSpinner: false });
          if (!progressCodes.includes(selectedcode)) {
            window.location.reload();
          }
        });
      console.log("FULL AI full analyse");
    } else if (
      selectedcode == "second-code" &&
      this.state.starttime === this.state.endtime
    ) {
      this.startProgressPolling(userId, "second-code");
      
      await this.resetProgress(userId);
      let secondEndpoint;
      if (this.state.analyzeServer === "Server 2") {
        secondEndpoint = `${apiUrl4}api/common/Analyse_classical_code_server2`;
      } else if (this.state.analyzeServer === "Server 1") {
        secondEndpoint = `${apiUrl4}api/common/Second_Code_Analysis`;
      } else if (this.state.analyzeServer === "Server 3") {
        secondEndpoint = `${apiUrl4}api/common/Analyse_classical_code_server3`;
      } else if (this.state.analyzeServer === "Main Server") {
        secondEndpoint = `${apiUrl4}api/common/Analyse_classical_code_main_server`;
      } else {
        secondEndpoint = `${apiUrl4}api/common/Second_Code_Analysis`;
      }
      axios.post(secondEndpoint, {
          userid: userId,
          startdate: startTime.replace(/%20/g, " "),
          enddate: endTime.replace(/%20/g, " "),
          analyzeServer: this.state.analyzeServer,
        })
        .then((response) => {
          console.log(response);
        })
        .catch((error) => {
          console.error("Second Code Analysis API Error (Progress polling continues):", error);
          try {
            this.startProgressPolling(userId, selectedcode, 2000);
          } catch (e) {
            console.error('Fallback polling start failed:', e);
          }
        })
        .finally(() => {
          this.setState({ showModalSpinner: false });
          if (!progressCodes.includes(selectedcode)) {
            window.location.reload();
          }
        });
      console.log("CLASSIC AI");
    } else if (
      selectedcode === "second-code" &&
      this.state.starttime !== this.state.endtime
    ) {
      this.startProgressPolling(userId, "second-code");
      
      await this.resetProgress(userId);
      let secondEndpointFull;
      if (this.state.analyzeServer === "Server 2") {
        secondEndpointFull = `${apiUrl4}api/common/Analyse_classical_code_server2`;
      } else if (this.state.analyzeServer === "Server 1") {
        secondEndpointFull = `${apiUrl4}api/common/Second_Code_Analysis`;
      } else if (this.state.analyzeServer === "Server 3") {
        secondEndpointFull = `${apiUrl4}api/common/Analyse_classical_code_server3`;
      } else if (this.state.analyzeServer === "Main Server") {
        secondEndpointFull = `${apiUrl4}api/common/Analyse_classical_code_main_server`;
      }
      axios.post(secondEndpointFull, {
          userid: userId,
          startdate: startTime.replace(/%20/g, " "),
          enddate: endTime.replace(/%20/g, " "),
          analyzeServer: this.state.analyzeServer,
        })
        .then((response) => {
          console.log(response);
          this.setState({ showModalSpinner: false });
          this.handleCloseModal();
          if (!progressCodes.includes(selectedcode)) {
            window.location.reload();
          }
        })
        .catch((error) => {
          console.error("Second Code Full Analysis API Error (Progress polling continues):", error);
          try {
            this.startProgressPolling(userId, selectedcode, 2000);
          } catch (e) {
            console.error('Fallback polling start failed:', e);
          }
        })
        .finally(() => {
          this.setState({ showModalSpinner: false });
          if (!progressCodes.includes(selectedcode)) {
            window.location.reload();
          }
        });
      console.log("CLASSIC AI full analyse");
    } else if (
      selectedcode == "third-code" &&
      this.state.starttime === this.state.endtime
    ) {
      this.setState({ showModalSpinner: false });
      this.startProgressPolling(userId, "third-code");
      
      await this.resetProgress(userId);
      let thirdEndpoint;
      if (this.state.analyzeServer === "Server 2") {
        thirdEndpoint = `${apiUrl4}api/common/Analyse_emergency_code_server2`;
      } else if (this.state.analyzeServer === "Server 1") {
        thirdEndpoint = `${apiUrl4}api/common/Analyse_emergency_code`;
      } else if (this.state.analyzeServer === "Server 3") {
        thirdEndpoint = `${apiUrl4}api/common/Analyse_emergency_code_server3`;
      } else if (this.state.analyzeServer === "Main Server") {
        thirdEndpoint = `${apiUrl4}api/common/Analyse_emergency_code_Main_Server`;
      }
      axios.post(thirdEndpoint, {
          userid: userId,
          startdate: startTime.replace(/%20/g, " "),
          enddate: endTime.replace(/%20/g, " "),
          analyzeServer: this.state.analyzeServer,
        })
        .then((response) => {
          console.log(response);
        })
        .catch((error) => {
          console.error("Third Code Analysis API Error (Progress polling continues):", error);
          try {
            this.startProgressPolling(userId, selectedcode, 2000);
          } catch (e) {
            console.error('Fallback polling start failed:', e);
          }
        })
        .finally(() => {
          this.setState({ showModalSpinner: false });
          if (!progressCodes.includes(selectedcode)) {
            window.location.reload();
          }
        });
      console.log("third-code");
    } else if (
      selectedcode == "third-code" &&
      this.state.starttime !== this.state.endtime
    ) {
      this.setState({ showModalSpinner: false });
      this.startProgressPolling(userId, "third-code");
      
      await this.resetProgress(userId);
      let thirdEndpointFull;
      if (this.state.analyzeServer === "Server 2") {
        thirdEndpointFull = `${apiUrl4}api/common/Analyse_emergency_code_server2`;
      } else if (this.state.analyzeServer === "Server 1") {
        thirdEndpointFull = `${apiUrl4}api/common/Analyse_emergency_code`;
      } else if (this.state.analyzeServer === "Server 3") {
        thirdEndpointFull = `${apiUrl4}api/common/Analyse_emergency_code_server3`;
      } else if (this.state.analyzeServer === "Main Server") {
        thirdEndpointFull = `${apiUrl4}api/common/Analyse_emergency_code_Main_Server`;
      }
      axios.post(thirdEndpointFull, {
          userid: userId,
          startdate: startTime.replace(/%20/g, " "),
          enddate: endTime.replace(/%20/g, " "),
          analyzeServer: this.state.analyzeServer,
        })
        .then((response) => {
          console.log(response);
        })
        .catch((error) => {
          console.error("Third Code Full Analysis API Error (Progress polling continues):", error);
          try {
            this.startProgressPolling(userId, selectedcode, 2000);
          } catch (e) {
            console.error('Fallback polling start failed:', e);
          }
        })
        .finally(() => {
          this.setState({ showModalSpinner: false });
          if (!progressCodes.includes(selectedcode)) {
            window.location.reload();
          }
        });
      console.log("third-code full analayse");
    } else if (selectedcode == "fourth-code") {
      this.setState({ showModalSpinner: false });
      this.startProgressPolling(userId, "fourth-code");
      
      await this.resetProgress(userId);
      let fourthEndpoint;
      if (this.state.analyzeServer === "Server 2") {
        fourthEndpoint = `${apiUrl4}api/common/Analyse_negative_code_server2`;
      } else if (this.state.analyzeServer === "Server 1") {
        fourthEndpoint = `${apiUrl4}api/common/Analyse_negative_code`;
      } else if (this.state.analyzeServer === "Server 3") {
        fourthEndpoint = `${apiUrl4}api/common/Analyse_negative_code_server3`;
      } else if (this.state.analyzeServer === "Main Server") {
        fourthEndpoint = `${apiUrl4}api/common/Analyse_negative_code_Main_Server`;
      }
      axios.post(fourthEndpoint, {
          userid: userId,
          startdate: startTime.replace(/%20/g, " "),
          enddate: endTime.replace(/%20/g, " "),
          analyzeServer: this.state.analyzeServer,
        })
        .then((response) => {
          console.log(response);
        })
        .catch((error) => {
          console.error("Fourth Code Analysis API Error (Progress polling continues):", error);
          try {
            this.startProgressPolling(userId, selectedcode, 2000);
          } catch (e) {
            console.error('Fallback polling start failed:', e);
          }
        })
        .finally(() => {
          this.setState({ showModalSpinner: false });
          if (!progressCodes.includes(selectedcode)) {
            window.location.reload();
          }
        });
      console.log("fourth-code" && this.state.starttime === this.state.endtime);
    } else if (
      selectedcode == "fourth-code" &&
      this.state.starttime !== this.state.endtime
    ) {
      this.setState({ showModalSpinner: false });
      this.startProgressPolling(userId, "fourth-code");
      
      let fourthEndpointFull;
      if (this.state.analyzeServer === "Server 2") {
        fourthEndpointFull = `${apiUrl4}api/common/Analyse_negative_code_server2`;
      } else if (this.state.analyzeServer === "Server 1") {
        fourthEndpointFull = `${apiUrl4}api/common/Analyse_negative_code`;
      } else if (this.state.analyzeServer === "Server 3") {
        fourthEndpointFull = `${apiUrl4}api/common/Analyse_negative_code_server3`;
      } else if (this.state.analyzeServer === "Main Server") {
        fourthEndpointFull = `${apiUrl4}api/common/Analyse_negative_code_Main_Server`;
      } else {
        fourthEndpointFull = `${apiUrl4}api/common/Analyse_negative_code`;
      }
      axios.post(fourthEndpointFull, {
          userid: userId,
          startdate: startTime.replace(/%20/g, " "),
          enddate: endTime.replace(/%20/g, " "),
          analyzeServer: this.state.analyzeServer,
        })
        .then((response) => {
          console.log(response);
        })
        .catch((error) => {
          console.error("Fourth Code Full Analysis API Error (Progress polling continues):", error);
          try {
            this.startProgressPolling(userId, selectedcode, 2000);
          } catch (e) {
            console.error('Fallback polling start failed:', e);
          }
        })
        .finally(() => {
          this.setState({ showModalSpinner: false });
          if (!progressCodes.includes(selectedcode)) {
            window.location.reload();
          }
        });
      console.log("fourth-code full analyse");
    } else if (selectedcode == "datacopy") {
      // Close the input modal and show the spinner while the API runs
      this.setState({
        showdatacopypopup: false,
        showModalSpinner: true,
      });

      const starttime = startTime.replace(/%20/g, " ");
      const endtimes = endTime.replace(/%20/g, " ");
      const correcttime = this.state.correctTime;

      try {
        const response = await axios.post(`${apiUrl}api/common/data-copy-run`, {
          userid: userId,
          starttime,
          endtime: endtimes,
          correcttime: correcttime,
        });
        console.log("Data copy successful:", response.data);
      } catch (error) {
        console.error(
          "Error during data copy:",
          error.response ? error.response.data : error.message
        );
      } finally {
        this.setState({ showModalSpinner: false });
        this.handleCloseModal();
        window.location.reload();
      }
    } else if (selectedcode === "analytics2") {
      this.setState({ showModalNew: false });
      try {
        // Reset server-side progress to 0 before starting analysis
        await this.resetProgress(userId);
        this.startProgressPolling(userId,"analytics2", 2000);
        this.setState({
          showProgressModal : true,
          showModalSpinner : false,
        });

        // Call the analysis API — ensure start/end are present (fallback to clickdata)
        const fallback = this.state.clickdata ? this.state.clickdata.replace(/%20/g, " ") : "";
        const startdate = startTime && startTime.trim() !== "" ? startTime.replace(/%20/g, " ") : fallback;
        const enddate = endTime && endTime.trim() !== "" ? endTime.replace(/%20/g, " ") : fallback;

        await axios.post(
          `${apiUrl4}api/common/Analyse_New_Modal1`,
          {
            userid: userId,
            databaseid: this.state.clickdata,
            startdate,
            enddate,
          },
          { timeout: 5 * 60 * 1000 }
        );
    
      } catch (error) {
        console.error("Analytics2 start error:", error);
        this.stopProgressPolling();
        this.setState({
          showModalNew : true,
          showModalSpinner : false,
          showProgressModal : false,
        });
      }
      return;
    }
  }

  handleDeletePopupClose() {
    this.setState({ showDeletePopup: false });
  }

  async deleteVerify(e) {
    const response = await axios.get(
      `${apiUrl}api/common/patinentmenutreeNew?userid=${this.state.userid}`
    );
    const treemenu = response.data;
    let optionnewon = []; // For ascending order
    let optionnewendon = []; // For descending order

    // Iterate over each date group in treemenu
    Object.keys(treemenu).forEach((dateKey) => {
      treemenu[dateKey].forEach((entry) => {
        const MainTimeon = entry.date.split("T");
        const timeon = MainTimeon[1].split("+")[0]; // Extract time portion, ignoring timezone

        // Create the formatted time string: "date time"
        const timeStr = `${dateKey} ${timeon}`;

        // Push to both arrays
        optionnewon.push(timeStr);
        optionnewendon.push(timeStr);
      });
    });

    // Sort optionnewon (ascending order) by full date-time
    optionnewon.sort((a, b) => {
      const fullDateA = new Date(a); // Convert full date-time string to Date object
      const fullDateB = new Date(b); // Convert full date-time string to Date object
      return fullDateA - fullDateB; // Ascending order: compare full date-time
    });

    // Sort optionnewendon (descending order) by full date-time
    optionnewendon.sort((a, b) => {
      const fullDateA = new Date(a); // Convert full date-time string to Date object
      const fullDateB = new Date(b); // Convert full date-time string to Date object
      return fullDateB - fullDateA; // Descending order: compare full date-time
    });

    const formattedOptionNewEndon = optionnewendon.map((value, index) => ({
      index,
      value,
    }));
    const formattedOptionNewStarton = optionnewon.map((value, index) => ({
      index,
      value,
    }));

    this.setState({ treemenu: formattedOptionNewEndon });
    this.setState({ treemenurev: formattedOptionNewStarton });
    this.setState({ starttime: this.state.clickdata.replace("%20", " ") });
    this.setState({ endtime: this.state.clickdata.replace("%20", " ") });
    this.setState({ showDeletePopup: true });
  }

  handleDeletePopupOk() {
    if (!window.confirm("Do you want to delete this Dataset?")) return;

    const userid = this.state.userid;
    const starttime = this.state.starttime;
    const endtime = this.state.endtime;

    // Close the delete modal and show the progress spinner while the API runs
    this.setState({
      showDeletePopup: false,
      showModalSpinner: true,
    });

    axios
      .post(`${apiUrl}api/common/explicit-delete`, {
        userid: userid,
        startdate: starttime.replace(/%20/g, " "),
        enddate: endtime.replace(/%20/g, " "),
      })
      .then(() =>
        axios.get(`${apiUrl}api/common/getLatestDatabaseId?userid=${userid}`)
      )
      .then((res) => {
        const latestDatabaseid = res.data;
        return axios.get(
          `${apiUrl}api/patients/getLatestDatabaseId?userid=${userid}&latestDatabaseid=${latestDatabaseid}`
        );
      })
      .then(() => {
        console.log("Removed");
      })
      .catch((err) => {
        console.error("Delete API error:", err);
      })
      .finally(() => {
        this.setState({ showModalSpinner: false });
        this.handleCloseModal();
        window.location.reload();
      });
  }

  // Start polling progress for specific analysis codes
  // intervalMs: optional polling frequency in milliseconds (default 1000ms)
  async startProgressPolling(userId, codeType, intervalMs = 2000) {
    // Only show progress modal for these specific analysis types
    const allowedCodeTypes = ["first-code", "second-code", "third-code", "fourth-code", "analytics2"];
    const shouldShowProgress = allowedCodeTypes.includes(codeType);
    // If codeType should not show progress, skip starting polling entirely
    if (!shouldShowProgress) {
      console.log(`Skipping progress polling for codeType=${codeType}`);
      return;
    }

    // clear any existing polling first
    if (this.state.progressInterval) {
      console.log('Clearing existing progressInterval before starting new one');
      clearInterval(this.state.progressInterval);
    }
    // Hide lightweight spinner and show the full progress modal when appropriate
    // Record start time so we don't auto-close the modal immediately if the
    // server occasionally returns 100% before the analysis actually completes.
    // Also ensure any other UI modals/popups are closed so only the progress
    // modal is shown while analysis runs.
    const baseState = {
      showModalSpinner: false,
      showProgressModal: shouldShowProgress,
      currentProgress: 0,
      progressComplete: false,
      // Always show percent while polling so UI updates are visible
      showProgressPercent: true,
      progressStartTime: Date.now(),
      // Reset phase fields so a previous failed/stale phase isn't shown
      analysisPhase: "queued",
      analysisPhaseDetail: null,
      analysisNodeHost: null,
    };

    if (shouldShowProgress) {
      Object.assign(baseState, {
        showModal: false,
        showModalNew: false,
        showAnlayseone: false,
        showAnalysetwo: false,
        showAnalysethree: false,
        showAnalyzefour: false,
        showInputPopup: false,
        showInvertorpopup: false,
        showdatacopypopup: false,
      });
    }

    this.setState(baseState);
    console.log(`startProgressPolling userId=${userId} codeType=${codeType} intervalMs=${intervalMs}`);

    // Do an immediate fetch so UI shows progress promptly, then start interval
    const fetchAndHandle = async () => {
      try {
        const url = `${apiUrl}api/common/getProgressStatus/${userId}`;
        console.log(`Fetching progress URL: ${url}`);
        const response = await axios.get(url);
        const data = response.data || {};
        const progress = parseInt(data.progress, 10) || 0;

        // Pull phase fields if backend is providing them (gracefully degrade
        // to legacy progress-only contract if not).
        const phase       = data.analysis_phase || null;
        const phaseDetail = data.analysis_phase_detail || null;
        const nodeHost    = data.analysis_node_host || null;

        this.setState({
          currentProgress: progress,
          analysisPhase: phase,
          analysisPhaseDetail: phaseDetail,
          analysisNodeHost: nodeHost,
        });
        console.log(`Progress user=${userId} code=${codeType}: ${progress}% phase=${phase || "n/a"} host=${nodeHost || "n/a"}`);

        // Terminal failed state — stop polling, flag the modal
        if (phase === "failed") {
          console.warn(`Analysis failed for user=${userId}: ${phaseDetail}`);
          this.setState({ progressComplete: true, showProgressPercent: false });
          setTimeout(() => this.setState({ showProgressModal: false }), 2500);
          return true;
        }

        if (progress >= 100) {
          const minCloseDelayMs = 2000;
          const elapsed = this.state.progressStartTime ? Date.now() - this.state.progressStartTime : 0;
          if (elapsed < minCloseDelayMs) {
            this.setState({ currentProgress: 100 });
            console.log(`Progress at 100% too soon for user=${userId} code=${codeType}; elapsed=${elapsed}ms`);
            return false; // continue polling
          } else {
            console.log(`Progress reached 100% for user=${userId} code=${codeType}; stopping polling (immediate)`);
            this.setState({ progressInterval: null, progressComplete: true, currentProgress: 100, showProgressPercent: false, progressStartTime: null });
            setTimeout(() => this.setState({ showProgressModal: false }), 800);
            return true; // finished
          }
        }
        return false;
      } catch (error) {
        console.error('Error fetching progress:', error);
        return false;
      }
    };

    // run once immediately
    const finished = await fetchAndHandle();

    const interval = setInterval(async () => {
      try {
        const done = await fetchAndHandle();
        if (done) {
          clearInterval(this._progressInterval);
          this._progressInterval = null;
        }
      } catch (e) {
        console.error('Interval fetch error:', e);
      }
    }, intervalMs);

    // Store interval id on instance to avoid issues with setState batching
    this._progressInterval = interval;
    this.setState({ progressInterval: interval });
  }

  // Stop progress polling
  stopProgressPolling() {
    if (this._progressInterval) {
      console.log(`stopProgressPolling called for user=${this.state.userid}`);
      clearInterval(this._progressInterval);
      this._progressInterval = null;
    }
    if (this.state.progressInterval) {
      clearInterval(this.state.progressInterval);
    }
    // Stop polling but keep the modal visible (do not auto-close)
    this.setState({ progressInterval: null, showProgressPercent: false, progressStartTime: null });
  }

  // Close progress modal and clear polling
  handleCloseProgressModal() {
    if (this._progressInterval) {
      console.log(`handleCloseProgressModal called for user=${this.state.userid}`);
      clearInterval(this._progressInterval);
      this._progressInterval = null;
    }
    if (this.state.progressInterval) {
      clearInterval(this.state.progressInterval);
    }
    this.setState({ progressInterval: null, showProgressModal: false, showProgressPercent: false, progressStartTime: null });
  }

  async analyzeDataset(e) {
    var userid = this.state.userid;
    var databaseid = this.state.clickdata;
    if (e.currentTarget.id == "ai") {
      //  console.log("Analyse last");
      //   console.log('Select',e.currentTarget.id);
      window.analyzeLink =
        "/home/ubuntu/analysis_codes/ai_codes/analyze_last_correct.py";
    } else if (e.currentTarget.id == "hybrid") {
      // console.log('Select',e.currentTarget.id);
      window.analyzeLink =
        "/home/ubuntu/analysis_codes/emergency_code/analyze_last_correct.py";
    } else if (e.currentTarget.id == "classical") {
      //   console.log('Select',e.currentTarget.id);
      window.analyzeLink =
        "/home/ubuntu/analysis_codes/classical_code/analyze_last_correct.py";
    } else if (e.currentTarget.id == "temp1") {
      //    console.log('Select',e.currentTarget.id);
      window.analyzeLink =
        "/home/ubuntu/analysis_codes/negpeak/analyze_last_correct.py";
    } else if (e.currentTarget.id == "temp2") {
      //    console.log('Select',e.currentTarget.id);
      window.analyzeLink =
        "/home/ubuntu/analysis_codes/pvc_model/analyze_last_correct.py";
    } else if (e.currentTarget.id == "inversion") {
      console.log("Inversion single data");
      console.log("databaseid !!!!!!!!!!!!!!!!", databaseid);
      window.analyzeLink = "/home/ubuntu/web_analysis/single_invert.py";
    }
    //  console.log('window.analyzeLink',window.analyzeLink);
    // console.log('uid',userid);
    //  console.log('uid',databaseid);
    // console.log('&&databaseid=');
    if (window.analyzeLink != "") {
      var userid = this.state.userid;
      var databaseid = this.state.clickdata;
      e.currentTarget.innerHTML = "Analyzing...";
      //const userid = this.props.match.params.userid;
      this.handleCloseModalNew();
      // Reset server-side progress and start polling while analysis runs
      try {
        await this.resetProgress(userid);
        // map clicked id to a code type for the progress modal
        let codeType = null;
        if (e.currentTarget && e.currentTarget.id) {
          const id = e.currentTarget.id;
          if (id === "ai" || id === "temp2") codeType = "first-code";
          else if (id === "classical") codeType = "second-code";
          else if (id === "hybrid") codeType = "third-code";
          else if (id === "temp1") codeType = "fourth-code";
          else if (id === "analytics2") codeType = "analytics2";
        }
        this.startProgressPolling(userid, codeType, 2000);

        this.handleOpenModalSpinnerNew();

        axios
          .get(
            "https://web.mybiocalculus.com/html/welcome/analyzeDataset/?userid=" +
              userid +
              "&&databaseid=" +
              databaseid +
              "&&url=" +
              window.analyzeLink
          )
          .then((res) => {
            console.log("database analys");
            console.log(
              "https://web.mybiocalculus.com/html/welcome/analyzeDataset/?userid=" +
                userid +
                "&&databaseid=" +
                databaseid +
                "&&url=" +
                window.analyzeLink
            );
            console.log(res.data);
            console.log(window.analyzeLink);
            // keep progress modal open; spinner can be closed
            this.handleCloseModalSpinnerNew();
          })
          .catch((err) => {
            console.error('analyzeDataset start error:', err);
            // stop spinner and polling on error
            this.handleCloseModalSpinnerNew();
            this.stopProgressPolling();
          });
      } catch (err) {
        console.error('Failed to start analysis polling:', err);
        this.handleCloseModalSpinnerNew();
      }
    }
  }
  /* _onSelect(e)
  {
  
    if(e.value=='RPeaks')
    {
        console.log('Select',e.value);
        window.analyzeLink='/home/biocalculusssh/web_analysis/rpeaks_codes/analyze_last_correct.py';
    }
    else if(e.value=='Classic')
    {
        console.log('Select',e.value);
        window.analyzeLink='/home/biocalculusssh/web_analysis/classic_peak/analyze_last_correct.py';
    }
    else if(e.value=='Classical')
    {
        console.log('Select',e.value);
        window.analyzeLink='/home/biocalculusssh/web_analysis/classical_code/analyze_last_correct.py';
    }
    else if(e.value=='Classic Negative')
    {
        console.log('Select',e.value);
        window.analyzeLink='/home/biocalculusssh/web_analysis/classic_negpeak/analyze_last_correct.py';
    }
    else if(e.value=='AI')
    {
        console.log('Select',e.value);
        window.analyzeLink='/home/biocalculusssh/web_analysis/ai_codes/analyze_last_correct.py';
    }
    else if(e.value=='AIcodes')
    {
        console.log('Select',e.value);
        window.analyzeLink='/home/biocalculusssh/web_analysis/saroja_aicodes/analyze_last_correct.py';
    }
   
  }
*/
  renderLoading() {
    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1000,
        }}
      >
        <div style={{ textAlign: "center" }}>
          <p style={{ fontSize: "20px", color: "white", marginBottom: "20px" }}>
            Copying Data...
          </p>
          <div
            style={{ display: "flex", justifyContent: "center", gap: "5px" }}
          >
            {[...Array(5)].map((_, index) => (
              <div
                key={index}
                style={{
                  width: "10px",
                  height: "40px",
                  backgroundColor: "white",
                  animation: `bounce 1s infinite ease-in-out`,
                  animationDelay: `${index * 0.2}s`,
                }}
              ></div>
            ))}
          </div>
          <style>
            {`
                        @keyframes bounce {
                            0%, 100% {
                                transform: scaleY(1);
                            }
                            50% {
                                transform: scaleY(0.5);
                            }
                        }
                    `}
          </style>
        </div>
      </div>
    );
  }

  render() {
    if (this.state.showLoading) {
      return this.renderLoading(); // Render loading indicator when loading
    }
    /* const imageList = [{
  src: '../../dist/img/AI.png',
  width: 152,
  height: 102
}, {
  src: '../../dist/img/AI.png',
  width: 152,
  height: 102
}, {
  src: '../../dist/img/AI.png',
  width: 152,
  height: 102
}, {
  src: '../../dist/img/AI.png',
  width: 152,
  height: 102
},{
  src: '../../dist/img/AI.png',
  width: 152,
  height: 102
}, {
  src: '../../dist/img/AI.png',
  width: 152,
  height: 102
}]; */
    const customStyles = {
      content: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)", // Ensures perfect centering
        background: "transparent",
        border: "none", // Removes borders
        padding: 0, // Ensures no extra space around content
        display: "flex", // Aligns spinner properly
        justifyContent: "center", // Centers spinner horizontally
        alignItems: "center", // Centers spinner vertically
      },
      overlay: {
        backgroundColor: "rgba(0, 0, 0, 0.5)", // Adds a semi-transparent overlay
      },
    };
    const customStylesNew = {
      overlay: {
        backgroundColor: "rgba(15, 23, 42, 0.65)",
        backdropFilter: "blur(6px)",
        WebkitBackdropFilter: "blur(6px)",
        zIndex: 1050,
      },
      content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        border: "none",
        background: "linear-gradient(160deg, #0f172a 0%, #1e293b 100%)",
        color: "#f1f5f9",
        overflow: "auto",
        borderRadius: "16px",
        outline: "none",
        padding: "32px",
        width: "min(720px, 92vw)",
        maxHeight: "85vh",
        boxShadow: "0 25px 60px rgba(0,0,0,0.45), 0 0 0 1px rgba(148,163,184,0.15)",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
      },
    };

    // Picker model — keeps existing IDs & handlers; only display layer is modernized.
    // ID/label remap follows the standardised analysis-pipeline naming.
    const pickerCardStyle = {
      background: "rgba(15,23,42,0.7)",
      borderRadius: "14px",
      padding: "16px 12px",
      cursor: "pointer",
      border: "1px solid rgba(148,163,184,0.18)",
      transition: "transform 200ms ease, border-color 200ms ease, box-shadow 200ms ease",
      textAlign: "center",
      width: "100%",
      display: "block",
    };
    const pickerImgWell = {
      background: "transparent",
      borderRadius: "10px",
      padding: "10px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "82px",
    };
    const pickerImg = {
      maxWidth: "100%",
      maxHeight: "62px",
      objectFit: "contain",
      pointerEvents: "none",
    };

    // Brand colors — match the reference logo system
    const brand = {
      fullAi:    "#2D7EF7", // blue
      hybrid:    "#3F8E48", // green
      classical: "#E96D2D", // orange
      negPeak:   "#7E3F98", // purple
      rapidAi:   "#1FA9A0", // teal
      invert:    "#2D7EF7", // blue
      snapshot:  "#3F8E48", // green
    };

    // Reusable colored-circle wrapper for inline SVG glyphs
    const IconCircle = ({ color, children }) => (
      <div style={{
        width: "62px",
        height: "62px",
        borderRadius: "50%",
        background: color,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: "0 auto",
        boxShadow: `0 6px 16px ${color}55`
      }}>
        <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          {children}
        </svg>
      </div>
    );

    // 1. Full AI — heart pulse + neural net dot
    const FullAiIcon = () => (
      <IconCircle color={brand.fullAi}>
        <path d="M3 12h3l2-4 2 7 2-5 1 2h2" />
        <circle cx="18" cy="9" r="1.4" fill="#fff" />
        <circle cx="20.5" cy="13" r="1.2" fill="#fff" />
        <circle cx="17" cy="14.5" r="1.2" fill="#fff" />
        <line x1="18" y1="9" x2="20.5" y2="13" />
        <line x1="18" y1="9" x2="17" y2="14.5" />
        <line x1="20.5" y1="13" x2="17" y2="14.5" />
      </IconCircle>
    );

    // 2. Hybrid — brain + gear (Classical + AI)
    const HybridIcon = () => (
      <IconCircle color={brand.hybrid}>
        <path d="M9 5a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3" />
        <path d="M9 5v14" />
        <circle cx="16" cy="12" r="2.2" />
        <path d="M16 8.5v1.3M16 14.2v1.3M19.5 12h-1.3M13.8 12h-1.3" />
      </IconCircle>
    );

    // 3. Classical — interlocking gears
    const ClassicalIcon = () => (
      <IconCircle color={brand.classical}>
        <circle cx="9" cy="10" r="3" />
        <path d="M9 5.5v1.5M9 13v1.5M4.5 10h1.5M12 10h1.5" />
        <circle cx="15.5" cy="14.5" r="2.2" />
        <path d="M15.5 11.3v1.2M15.5 16.5v1.2M12.3 14.5h1.2M17.7 14.5h1.2" />
      </IconCircle>
    );

    // 4. Negative Peak — ECG with deep downward spike
    const NegPeakIcon = () => (
      <IconCircle color={brand.negPeak}>
        <path d="M3 12h4l2-3 2 8 1.5-12 1.5 7 2-3h5" />
      </IconCircle>
    );

    // 5. Rapid AI — speedometer with motion lines
    const RapidAiIcon = () => (
      <IconCircle color={brand.rapidAi}>
        <path d="M3 12a8 8 0 0 1 16 0" />
        <line x1="11" y1="12" x2="15" y2="8" />
        <circle cx="11" cy="12" r="0.9" fill="#fff" />
        <line x1="3.5" y1="15.5" x2="6.5" y2="15.5" />
        <line x1="2.5" y1="18" x2="5.5" y2="18" />
      </IconCircle>
    );

    // 6. Invert — two opposing arrows
    const InvertIcon = () => (
      <IconCircle color={brand.invert}>
        <line x1="4" y1="9" x2="18" y2="9" />
        <polyline points="15,6 18,9 15,12" />
        <line x1="20" y1="15" x2="6" y2="15" />
        <polyline points="9,18 6,15 9,12" />
      </IconCircle>
    );

    // 6b. Amp Increase — wave with upward amplitude arrow
    const AmpIncreaseIcon = () => (
      <IconCircle color="#E96D2D">
        <path d="M3 14h2l1.5-3 1.5 5 1.5-7 1.5 5h2" />
        <line x1="18" y1="14" x2="18" y2="6" />
        <polyline points="15.5,8.5 18,6 20.5,8.5" />
      </IconCircle>
    );

    // 8. Delete — trash bin (destructive — uses red instead of brand color)
    const DeleteIcon = () => (
      <IconCircle color="#EF4444">
        <polyline points="3 6 5 6 21 6" />
        <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
        <line x1="10" y1="11" x2="10" y2="17" />
        <line x1="14" y1="11" x2="14" y2="17" />
        <path d="M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2" />
      </IconCircle>
    );

    // ---- Sub-modal helper (per-pipeline picker) ----------------------------
    // Server values MUST match what handleSelectorOk checks ("Server 1",
    // "Server 2", "Main Server"). Display labels follow the standardised
    // pool/sequence naming. Add new servers here once their backend
    // endpoints are wired in handleSelectorOk.
    // ---------------------------------------------------------------------
    // Naming convention shared with backend
    // ---------------------------------------------------------------------
    // Server canonical IDs (use these everywhere — UI, backend `analysis_node_host`,
    // dispatcher logs, log file names). The dropdown still sends the legacy
    // "Server 1 / Server 2 / Server 3 / Main Server" values for backward
    // compatibility, but the backend should rewrite them to canonical form
    // (vm-a1, vm-a2, etc.) when storing in `analysis_node_host`.
    //
    //   Pool A (analysis):   vm-a1 / vm-a2 / vm-a3 / vm-a4-azure
    //   Pool B (rapid AI):   vm-b1 / vm-b2
    //
    // Pipeline canonical IDs (already used in `analyzeModal`):
    //   first-code   = Full AI
    //   second-code  = Hybrid
    //   third-code   = Classical
    //   fourth-code  = NegPeak
    //   analytics2   = Rapid AI
    //   inversion    = Invert (utility)
    //   datacopy     = Data Sync (utility)
    //
    // Phase canonical values (backend writes, UI reads):
    //   queued | ssh_connecting | ssh_connected | running | stuck | failed | complete

    const serverHostDisplayName = {
      "vm-a1":        "VM-A1 · On-Premises · IP:11",
      "vm-a2":        "VM-A2 · On-Premises · IP:14",
      "vm-a3":        "VM-A3 · On-Premises · IP:111",
      "vm-a4-azure":  "VM-A4 · Azure · IP:77",
      "vm-b1":        "VM-B1 · On-Premises · IP:12",
      "vm-b2":        "VM-B2 · On-Premises · IP:119",
    };

    const phaseConfig = {
      queued:          { color: "#94a3b8", label: "QUEUED",         desc: "Waiting to be dispatched" },
      ssh_connecting:  { color: "#38bdf8", label: "CONNECTING",     desc: "Reaching the analysis server" },
      ssh_connected:   { color: "#38bdf8", label: "CONNECTED",      desc: "Launching analysis script" },
      running:         { color: "#10b981", label: "RUNNING",        desc: "Analysis in progress" },
      stuck:           { color: "#f59e0b", label: "STUCK",          desc: "No update for over 2 minutes" },
      failed:          { color: "#ef4444", label: "FAILED",         desc: "Analysis stopped with an error" },
      complete:        { color: "#10b981", label: "COMPLETE",       desc: "Analysis finished" },
    };

    // Pool A — analysis pipelines (4 servers)
    const poolA = [
      { value: "Server 1",    label: "VM-A1 · On-Premises · IP:11"  },
      { value: "Server 2",    label: "VM-A2 · On-Premises · IP:14"  },
      { value: "Server 3",    label: "VM-A3 · On-Premises · IP:111" },
      { value: "Main Server", label: "VM-A4 · Azure · IP:77"        },
    ];
    // Pool B — Rapid AI (2 servers)
    const poolB = [
      { value: "Server 1", label: "VM-B1 · On-Premises · IP:12"  },
      { value: "Server 2", label: "VM-B2 · On-Premises · IP:119" },
    ];
    const serverOptionsByPipeline = {
      "first-code":  poolA, // Full AI
      "second-code": poolA, // Hybrid
      "third-code":  poolA, // Classical
      "fourth-code": poolA, // NegPeak
      "analytics2":  poolB, // Rapid AI
    };

    const subModalLabel = { display: "block", color: "#94a3b8", fontSize: "12px", fontWeight: 600, letterSpacing: "0.08em", textTransform: "uppercase", marginBottom: "6px" };
    const subModalSelect = {
      width: "100%",
      padding: "10px 12px",
      fontSize: "14px",
      borderRadius: "8px",
      border: "1px solid rgba(148,163,184,0.3)",
      background: "rgba(15,23,42,0.6)",
      color: "#f1f5f9",
      outline: "none",
      cursor: "pointer",
    };
    const subModalCard = {
      background: "linear-gradient(160deg, rgba(30,41,59,0.95) 0%, rgba(15,23,42,0.95) 100%)",
      borderRadius: "14px",
      padding: "24px",
      boxShadow: "0 0 0 1px rgba(148,163,184,0.15)",
    };
    const okBtn = (color) => ({
      flex: 1,
      padding: "10px 18px",
      background: color,
      color: "#fff",
      border: "none",
      borderRadius: "8px",
      cursor: "pointer",
      fontWeight: 600,
      fontSize: "14px",
      letterSpacing: "0.04em",
      transition: "filter 150ms ease",
    });
    const cancelBtn = {
      flex: 1,
      padding: "10px 18px",
      background: "rgba(239,68,68,0.85)",
      color: "#fff",
      border: "none",
      borderRadius: "8px",
      cursor: "pointer",
      fontWeight: 600,
      fontSize: "14px",
      letterSpacing: "0.04em",
    };
    const datasetBadge = {
      display: "inline-block",
      padding: "4px 10px",
      borderRadius: "999px",
      background: "rgba(56,189,248,0.15)",
      color: "#7dd3fc",
      fontSize: "11px",
      fontWeight: 600,
      letterSpacing: "0.04em",
      marginLeft: "10px",
      verticalAlign: "middle",
    };

    // Modern body for utility modals (Invert / Amp Increase / Data Sync / Delete)
    // — no server selector, optional extra field, accent-colored OK button.
    const renderUtilityModalBody = ({ title, accent, onOk, onCancel, extraField }) => {
      const datasetId = (this.state.clickdata || "").replace(/%20/g, " ") || "—";
      return (
        <div style={subModalCard}>
          <div style={{ marginBottom: "20px" }}>
            <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}>
              <h3 style={{ margin: 0, fontSize: "18px", fontWeight: 700, color: "#f8fafc", letterSpacing: "0.04em", textTransform: "uppercase", fontFamily: '"Inter", "Segoe UI", system-ui, -apple-system, sans-serif' }}>{title}</h3>
              <span style={datasetBadge}>Dataset · {datasetId}</span>
            </div>
          </div>

          <div style={{ marginBottom: "16px" }}>
            <label style={subModalLabel}>Starting Date</label>
            <select
              style={subModalSelect}
              value={this.state.starttime}
              onChange={(e) => this.setState({ starttime: e.target.value })}
            >
              {Array.isArray(this.state.treemenu) && this.state.treemenu.map((item, index) => (
                <option key={index} value={item.value} style={{ color: "#000" }}>{item.value || "No Value"}</option>
              ))}
            </select>
          </div>

          <div style={{ marginBottom: "16px" }}>
            <label style={subModalLabel}>Ending Date</label>
            <select
              style={subModalSelect}
              value={this.state.endtime}
              onChange={(e) => this.setState({ endtime: e.target.value })}
            >
              {Array.isArray(this.state.treemenurev) && this.state.treemenurev.map((item, index) => (
                <option key={index} value={item.value} style={{ color: "#000" }}>{item.label || item.value || "No Label"}</option>
              ))}
            </select>
          </div>

          {extraField && (
            <div style={{ marginBottom: "16px" }}>
              <label style={subModalLabel}>{extraField.label}</label>
              <input
                type="text"
                style={subModalSelect}
                value={extraField.value || ""}
                onChange={extraField.onChange}
                placeholder={extraField.placeholder || ""}
              />
            </div>
          )}

          <div style={{ display: "flex", gap: "12px", marginTop: "20px" }}>
            <button style={okBtn(accent)} onClick={onOk}>OK</button>
            <button style={cancelBtn} onClick={onCancel}>Cancel</button>
          </div>
        </div>
      );
    };

    const renderSubModalBody = (title, accent, pipelineKey) => {
      const servers = serverOptionsByPipeline[pipelineKey] || [];
      const datasetId = (this.state.clickdata || "").replace(/%20/g, " ") || "—";
      return (
        <div style={subModalCard}>
          <div style={{ marginBottom: "20px" }}>
            <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}>
              <h3 style={{ margin: 0, fontSize: "18px", fontWeight: 700, color: "#f8fafc", letterSpacing: "0.04em", textTransform: "uppercase" }}>{title}</h3>
              <span style={datasetBadge}>Dataset · {datasetId}</span>
            </div>
            <p style={{ margin: "6px 0 0", fontSize: "12px", color: "#94a3b8" }}>Pick a server, then run on this dataset or a custom time range.</p>
          </div>

          {servers.length > 0 && (
            <div style={{ marginBottom: "16px" }}>
              <label style={subModalLabel}>Select Server</label>
              <select
                style={subModalSelect}
                value={this.state.analyzeServer}
                onChange={(e) => this.setState({ analyzeServer: e.target.value })}
              >
                {servers.map((s) => (<option key={s.value} value={s.value} style={{ color: "#000" }}>{s.label}</option>))}
              </select>
            </div>
          )}

          <div style={{ marginBottom: "16px" }}>
            <label style={subModalLabel}>Starting Date</label>
            <select
              style={subModalSelect}
              value={this.state.starttime}
              onChange={(e) => this.setState({ starttime: e.target.value })}
            >
              {Array.isArray(this.state.treemenu) && this.state.treemenu.map((item, index) => (
                <option key={index} value={item.value} style={{ color: "#000" }}>{item.value || "No Value"}</option>
              ))}
            </select>
          </div>

          <div style={{ marginBottom: "16px" }}>
            <label style={subModalLabel}>Ending Date</label>
            <select
              style={subModalSelect}
              value={this.state.endtime}
              onChange={(e) => this.setState({ endtime: e.target.value })}
            >
              {Array.isArray(this.state.treemenurev) && this.state.treemenurev.map((item, index) => (
                <option key={index} value={item.value} style={{ color: "#000" }}>{item.label || item.value || "No Label"}</option>
              ))}
            </select>
          </div>

          <div style={{ display: "flex", gap: "12px", marginTop: "20px" }}>
            <button style={okBtn(accent)} onClick={this.handleSelectorOk.bind(this)}>OK</button>
            {["first-code", "second-code", "third-code", "fourth-code"].includes(pipelineKey) && (
              <button
                style={okBtn("#0891b2")}
                onClick={this.handleAddToQueue}
                title="Add to the sequential analysis queue — runs one at a time; listed on the Analysis Dashboard"
              >
                Queue
              </button>
            )}
            <button style={cancelBtn} onClick={this.handleInputPopupClose.bind(this)}>Cancel</button>
          </div>
        </div>
      );
    };

    // 7. Snapshot (data replication) — database with circular arrows
    const SnapshotIcon = () => (
      <IconCircle color={brand.snapshot}>
        <ellipse cx="12" cy="7" rx="5" ry="2" />
        <path d="M7 7v6c0 1.1 2.2 2 5 2s5-.9 5-2V7" />
        <path d="M7 12c0 1.1 2.2 2 5 2s5-.9 5-2" />
        <path d="M3.5 16a4 4 0 0 0 4 4" />
        <polyline points="3.5,18.5 3.5,16 6,16" />
      </IconCircle>
    );
    const pickerLabel = {
      marginTop: "12px",
      fontSize: "14px",
      fontWeight: 700,
      letterSpacing: "0.04em",
      color: "#ffffff",
      textTransform: "uppercase",
      fontFamily: '"Inter", "Segoe UI", system-ui, -apple-system, sans-serif',
    };
    const pickerSubLabel = {
      marginTop: "5px",
      fontSize: "12px",
      color: "#cbd5e1",
      letterSpacing: "0.02em",
      fontWeight: 500,
      fontFamily: '"Inter", "Segoe UI", system-ui, -apple-system, sans-serif',
    };
    const sectionHeaderStyle = {
      display: "flex",
      alignItems: "center",
      gap: "10px",
      margin: "12px 0 14px",
      fontSize: "12px",
      fontWeight: 800,
      letterSpacing: "0.22em",
      textTransform: "uppercase",
      color: "#f1f5f9",
      fontFamily: '"Inter", "Segoe UI", system-ui, -apple-system, sans-serif',
    };
    const sectionLineStyle = {
      flex: 1,
      height: "1px",
      background: "linear-gradient(90deg, rgba(148,163,184,0.3), rgba(148,163,184,0))",
    };
    const sectionPillStyle = (color) => ({
      display: "inline-block",
      width: "6px",
      height: "6px",
      borderRadius: "50%",
      background: color,
      boxShadow: `0 0 10px ${color}`,
    });
    const closeBtnModern = {
      position: "absolute",
      top: "16px",
      right: "16px",
      width: "32px",
      height: "32px",
      borderRadius: "50%",
      border: "none",
      background: "rgba(148,163,184,0.18)",
      color: "#e2e8f0",
      fontSize: "14px",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transition: "background 180ms ease",
      zIndex: 2,
    };
    const liftCard = (e, color) => {
      e.currentTarget.style.transform = "translateY(-3px)";
      e.currentTarget.style.borderColor = `${color}88`;
      e.currentTarget.style.boxShadow = `0 18px 35px ${color}33`;
    };
    const dropCard = (e) => {
      e.currentTarget.style.transform = "translateY(0)";
      e.currentTarget.style.borderColor = "rgba(148,163,184,0.18)";
      e.currentTarget.style.boxShadow = "none";
    };
    const text = "Analyzing....";
    //  const options = [
    //        'RPeaks', 'Classic', 'Classical','Classic Negative', 'AI','AIcodes'
    //       ];
    //        const defaultOption = options[0];
    // console.log(this.state.showModal)
    return (
      <React.Fragment>
            <ReactModal
              isOpen={this.state.showModalSpinner || this.state.showProgressModal}
              style={{
                overlay: {
                  backgroundColor: "rgba(15, 23, 42, 0.75)",
                  backdropFilter: "blur(8px)",
                  WebkitBackdropFilter: "blur(8px)",
                  zIndex: 1100,
                },
                content: {
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  background: "linear-gradient(160deg, #0f172a 0%, #1e293b 100%)",
                  border: "none",
                  borderRadius: "16px",
                  padding: "36px 44px",
                  width: "min(360px, 90vw)",
                  textAlign: "center",
                  boxShadow: "0 25px 60px rgba(0,0,0,0.45), 0 0 0 1px rgba(148,163,184,0.18)",
                  color: "#f1f5f9",
                },
              }}
            >
              {(() => {
                const phase = this.state.analysisPhase;
                const cfg = phase && phaseConfig[phase];
                const headline = cfg ? cfg.label : "PROCESSING…";
                const sub = cfg ? cfg.desc : "Page will reload when complete";
                const accent = cfg ? cfg.color : "#10b981";
                const hostId = this.state.analysisNodeHost;
                const hostLabel = hostId
                  ? (serverHostDisplayName[hostId] || hostId)
                  : null;
                return (
                  <div style={{ textAlign: "center", fontFamily: '"Inter", "Segoe UI", system-ui, -apple-system, sans-serif' }}>
                    <AnalyzingSpinner
                      progress={this.state.currentProgress}
                      showPercent={this.state.showProgressPercent}
                      size={110}
                    />

                    {/* Phase chip */}
                    <div style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "8px",
                      marginTop: "20px",
                      padding: "6px 14px",
                      borderRadius: "999px",
                      border: `1px solid ${accent}55`,
                      background: `${accent}1f`,
                      color: accent,
                      fontSize: "12px",
                      fontWeight: 700,
                      letterSpacing: "0.14em",
                    }}>
                      <span style={{
                        display: "inline-block",
                        width: "6px",
                        height: "6px",
                        borderRadius: "50%",
                        background: accent,
                        boxShadow: `0 0 10px ${accent}`,
                      }}></span>
                      {headline}
                    </div>

                    <div style={{
                      marginTop: "10px",
                      fontSize: "13px",
                      color: "#cbd5e1",
                    }}>
                      {sub}
                    </div>

                    {/* Phase detail (e.g. "dataset 12 of 25") */}
                    {this.state.analysisPhaseDetail && (
                      <div style={{
                        marginTop: "6px",
                        fontSize: "12px",
                        color: "#94a3b8",
                      }}>
                        {this.state.analysisPhaseDetail}
                      </div>
                    )}

                    {/* Server badge */}
                    {hostLabel && (
                      <div style={{
                        marginTop: "12px",
                        display: "inline-block",
                        padding: "4px 10px",
                        borderRadius: "8px",
                        background: "rgba(56,189,248,0.15)",
                        color: "#7dd3fc",
                        fontSize: "11px",
                        fontWeight: 600,
                        letterSpacing: "0.04em",
                      }}>
                        {hostLabel}
                      </div>
                    )}

                    <div className="bounce-container" style={{ marginTop: "16px" }}>
                      {text.split("").map((char, index) => (
                        <span key={index} className="bounce-letter" style={{ animationDelay: `${index * 0.1}s`, color: "#94a3b8" }}>
                          {char}
                        </span>
                      ))}
                    </div>
                  </div>
                );
              })()}
            </ReactModal>

        {/* Progress Modal with Circular Progress */}
        {/* <ReactModal
          isOpen={this.state.showProgressModal}
          style={{
            content: {
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              background: "white",
              border: "1px solid #ddd",
              padding: "40px",
              borderRadius: "8px",
              width: "300px",
              textAlign: "center",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            },
            overlay: {
              backgroundColor: "rgba(0, 0, 0, 0.5)",
            },
          }}
          contentLabel="Progress Modal"
        >
          <div>
            <h3 style={{ color: "#333", marginBottom: "20px" }}>Analyzing...!!!</h3>
            <div style={{ margin: "0 auto 10px", width: 220 }}>
              <AnalyzingSpinner
                progress={this.state.currentProgress}
                showPercent={this.state.showProgressPercent}
                size={140}
              />
            </div>
            <p style={{ color: "#666", fontSize: "14px" }}>
              Please wait while we process your data...
            </p>
          </div>
        </ReactModal> */}
       
        <ReactModal
          isOpen={this.state.showModal && !this.state.showProgressModal}
          style={customStyles}
          contentLabel="Example Modal"
        >
          <React.Fragment>
            <div className="blog-pop-bg"></div>
            <div className="blog-pop-box">
              <button
                className="pull-right closeBtn"
                onClick={this.handleCloseModal}
              >
                &#10006;
              </button>

              <div className="fea pull-left" style={{ marginRight: "50px" }}>
                {this.state.startProp == undefined && (
                  <button style={{ border: "none" }}>
                    <img
                      onClick={this.openAnalyzemodal.bind(this)}
                      src="../../dist/img/blog-pop1.png"
                      alt=""
                    />
                  </button>
                )}
                {this.state.startProp != undefined && (
                  <button style={{ border: "none" }}>
                    <img
                      onClick={this.openAnalyzemodal.bind(this)}
                      src="../../../../../dist/img/blog-pop1.png"
                      alt=""
                    />
                  </button>
                )}
                <p style={{ marginLeft: "30%", fontSize: "25px" }}>Analyze</p>
              </div>
              <div className="fea pull-right" style={{ marginLeft: "50px" }}>
                {this.state.startProp == undefined && (
                  <button style={{ border: "none" }}>
                    <img
                      onClick={this.deleteVerify.bind(this)}
                      src="../../dist/img/blog-pop2.png"
                      alt=""
                    />
                  </button>
                )}
                {this.state.startProp != undefined && (
                  <button style={{ border: "none" }}>
                    <img
                      onClick={this.deleteVerify.bind(this)}
                      src="../../../../../dist/img/blog-pop2.png"
                      alt=""
                    />
                  </button>
                )}
                <p style={{ marginLeft: "40%", fontSize: "25px" }}>DELETE</p>
              </div>
              <br />
            </div>
          </React.Fragment>
        </ReactModal>
        <ReactModal
          isOpen={this.state.showModalNew && !this.state.showProgressModal}
          style={customStylesNew}
          contentLabel="Analyze Modal"
        >
          <div style={{ position: "relative" }}>
            <button style={closeBtnModern} onClick={this.handleCloseModalNew} aria-label="Close">&#10006;</button>

            <div style={{ marginBottom: "20px", paddingRight: "40px" }}>
              <h3 style={{ margin: 0, fontSize: "20px", fontWeight: 700, color: "#f8fafc", letterSpacing: "0.02em" }}>Run on this dataset</h3>
              <p style={{ margin: "6px 0 0", fontSize: "13px", color: "#94a3b8" }}>Pick an analysis pipeline or a conditioning utility.</p>
            </div>

            <div style={sectionHeaderStyle}>
              <span style={sectionPillStyle("#10b981")}></span>
              <span>Analysis Pipelines</span>
              <span style={sectionLineStyle}></span>
            </div>

            <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "14px", marginBottom: "24px" }}>
              <button
                id="ai"
                style={pickerCardStyle}
                onMouseEnter={(e) => liftCard(e, "#10b981")}
                onMouseLeave={dropCard}
                onClick={() => this.setState({ showAnlayseone: true, analyzeModal: "first-code" })}
              >
                <div style={pickerImgWell}><FullAiIcon /></div>
                <div style={pickerLabel}>Full AI</div>
                <div style={pickerSubLabel}>Peak + Arrhythmia</div>
              </button>

              <button
                id="classical"
                style={pickerCardStyle}
                onMouseEnter={(e) => liftCard(e, "#10b981")}
                onMouseLeave={dropCard}
                onClick={() => this.setState({ showAnalysetwo: true, analyzeModal: "second-code" })}
              >
                <div style={pickerImgWell}><HybridIcon /></div>
                <div style={pickerLabel}>Hybrid</div>
                <div style={pickerSubLabel}>AI + Classical</div>
              </button>

              <button
                id="hybrid"
                style={pickerCardStyle}
                onMouseEnter={(e) => liftCard(e, "#10b981")}
                onMouseLeave={dropCard}
                onClick={() => this.setState({ showAnalysethree: true, analyzeModal: "third-code" })}
              >
                <div style={pickerImgWell}><ClassicalIcon /></div>
                <div style={pickerLabel}>Classical</div>
                <div style={pickerSubLabel}>Algorithm only</div>
              </button>

              <button
                id="temp1"
                style={pickerCardStyle}
                onMouseEnter={(e) => liftCard(e, "#10b981")}
                onMouseLeave={dropCard}
                onClick={() => this.setState({ showAnalyzefour: true, analyzeModal: "fourth-code" })}
              >
                <div style={pickerImgWell}><NegPeakIcon /></div>
                <div style={pickerLabel}>NegPeak</div>
                <div style={pickerSubLabel}>Negative-peak model</div>
              </button>

              <button
                id="analytics2"
                style={pickerCardStyle}
                onMouseEnter={(e) => liftCard(e, "#10b981")}
                onMouseLeave={dropCard}
                onClick={() => this.setState({ showAnlayseone: true, analyzeModal: "analytics2" })}
              >
                <div style={pickerImgWell}><RapidAiIcon /></div>
                <div style={pickerLabel}>Rapid AI</div>
                <div style={pickerSubLabel}>Faster inference</div>
              </button>
            </div>

            <div style={sectionHeaderStyle}>
              <span style={sectionPillStyle("#38bdf8")}></span>
              <span>Data Conditioning</span>
              <span style={sectionLineStyle}></span>
            </div>

            <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "14px" }}>
              <button
                id="temp2"
                style={pickerCardStyle}
                onMouseEnter={(e) => liftCard(e, "#38bdf8")}
                onMouseLeave={dropCard}
                onClick={async () => { await this.openAnalyzemodal(); this.setState({ showInputPopup: true }); }}
              >
                <div style={pickerImgWell}><AmpIncreaseIcon /></div>
                <div style={pickerLabel}>Amp Increase</div>
                <div style={pickerSubLabel}>Amplitude boost</div>
              </button>

              <button
                id="inversion"
                style={pickerCardStyle}
                onMouseEnter={(e) => liftCard(e, "#38bdf8")}
                onMouseLeave={dropCard}
                onClick={() => this.setState({ showInvertorpopup: true, analyzeModal: "inversion" })}
              >
                <div style={pickerImgWell}><InvertIcon /></div>
                <div style={pickerLabel}>Invert</div>
                <div style={pickerSubLabel}>Polarity flip</div>
              </button>

              <button
                id="datacopy"
                style={pickerCardStyle}
                onMouseEnter={(e) => liftCard(e, "#38bdf8")}
                onMouseLeave={dropCard}
                onClick={() => this.setState({ showdatacopypopup: true, analyzeModal: "datacopy" })}
              >
                <div style={pickerImgWell}><SnapshotIcon /></div>
                <div style={pickerLabel}>Data Sync</div>
                <div style={pickerSubLabel}>Link dataset</div>
              </button>

              <button
                id="delete"
                style={pickerCardStyle}
                onMouseEnter={(e) => liftCard(e, "#EF4444")}
                onMouseLeave={dropCard}
                onClick={(e) => this.deleteVerify(e)}
              >
                <div style={pickerImgWell}><DeleteIcon /></div>
                <div style={pickerLabel}>Delete</div>
                <div style={pickerSubLabel}>Remove dataset</div>
              </button>
            </div>
          </div>
        </ReactModal>
        {/* AMP INCREASE modal */}
        <ReactModal isOpen={this.state.showInputPopup && !this.state.showProgressModal} style={customStylesNew}>
          {renderUtilityModalBody({
            title: "Amp Increase",
            accent: "#E96D2D",
            onOk: this.handleInputPopupOk.bind(this),
            onCancel: this.handleInputPopupClose.bind(this),
            extraField: {
              label: "Enter the point to increase Amp",
              value: this.state.inputValue,
              onChange: this.handleInputChange.bind(this),
              placeholder: "e.g. 1.5",
            },
          })}
        </ReactModal>
        {/* end AMP INCREASE // start invert */}
        <ReactModal
          isOpen={this.state.showInvertorpopup}
          style={customStylesNew}
        >
          {renderUtilityModalBody({
            title: "Invert",
            accent: "#2D7EF7",
            onOk: this.handleSelectorOk.bind(this),
            onCancel: this.handleInputPopupClose.bind(this),
          })}
        </ReactModal>
        {/* end invert // start analyze FULL AI */}
        <ReactModal isOpen={this.state.showAnlayseone} style={customStylesNew}>
          {renderSubModalBody(
            this.state.analyzeModal === "analytics2" ? "Rapid AI" : "Full AI",
            this.state.analyzeModal === "analytics2" ? "#1FA9A0" : "#2D7EF7",
            this.state.analyzeModal === "analytics2" ? "analytics2" : "first-code"
          )}
        </ReactModal>
        {/* end analyze FULL AI // start analyze HYBRID */}
        <ReactModal isOpen={this.state.showAnalysetwo} style={customStylesNew}>
          {renderSubModalBody("Hybrid", "#3F8E48", "second-code")}
        </ReactModal>
        {/* end analyze HYBRID // start analyze CLASSICAL */}
        <ReactModal
          isOpen={this.state.showAnalysethree}
          style={customStylesNew}
        >
          {renderSubModalBody("Classical", "#E96D2D", "third-code")}
        </ReactModal>
        {/* end analyze CLASSICAL // start analyze NEGPEAK */}
        <ReactModal isOpen={this.state.showAnalyzefour} style={customStylesNew}>
          {renderSubModalBody("NegPeak", "#7E3F98", "fourth-code")}
        </ReactModal>
        {/* end analyze NEGPEAK */}
        <ReactModal isOpen={this.state.showDeletePopup} style={customStylesNew}>
          {renderUtilityModalBody({
            title: "Delete Dataset",
            accent: "#EF4444",
            onOk: this.handleDeletePopupOk,
            onCancel: this.handleDeletePopupClose,
          })}
        </ReactModal>
        <ReactModal
          isOpen={this.state.showdatacopypopup}
          style={customStylesNew}
        >
          {renderUtilityModalBody({
            title: "Data Sync",
            accent: "#3F8E48",
            onOk: this.handleSelectorOk.bind(this),
            onCancel: this.handleInputPopupClose.bind(this),
            extraField: {
              label: "Enter Correct Time",
              value: this.state.correctTime,
              onChange: (e) => this.setState({ correctTime: e.target.value }),
              placeholder: "YYYY-MM-DD HH:MM:SS",
            },
          })}
        </ReactModal>
        <ReactModal
          isOpen={this.state.showSuccessModal}
          style={{
            content: {
              top: "50%",
              left: "50%",
              right: "auto",
              bottom: "auto",
              marginRight: "-50%",
              transform: "translate(-50%, -50%)",
              border: "1px solid #ccc",
              background: "#fff",
              borderRadius: "8px",
              padding: "30px",
              textAlign: "center",
            },
          }}
          contentLabel="Success Modal"
        >
          <h2 style={{ color: "#4CAF50" }}>Success</h2>
          <p>{this.state.successMessage}</p>
          <button
            style={{
              padding: "10px 20px",
              backgroundColor: "#4CAF50",
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
              marginTop: "20px",
            }}
            onClick={() => this.setState({ showSuccessModal: false })}
          >
            Close
          </button>
        </ReactModal>
      </React.Fragment>
    );
  }
}

export default AddModal;
